/**
 * @generated SignedSource<<d91fa26f93d94a51b144344bf40fe2cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePaginationNavigationHistoryArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTrackCurrentItemBase">;
  readonly " $fragmentType": "articlePaginationNavigationHistoryArticle";
};
export type articlePaginationNavigationHistoryArticle$key = {
  readonly " $data"?: articlePaginationNavigationHistoryArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePaginationNavigationHistoryArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = [
  (v1/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v7/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "hooksUseNotificationsSection",
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "notificationSection",
        "selections": (v6/*: any*/),
        "args": null,
        "argumentDefinitions": ([]/*: any*/)
      },
      (v1/*: any*/)
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
],
v10 = [
  (v1/*: any*/),
  (v5/*: any*/)
];
return {
  "argumentDefinitions": (v0/*: any*/),
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePaginationNavigationHistoryArticle",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTrackCurrentItemBase",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentArticleAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": (v4/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "articleSeoArticle"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentShareWidgetContent"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "headerContentBookmarkArticle",
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "headerContentCommentTrigger",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "articleCommentsTriggerArticle"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersUseSharingUrl",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*: any*/)
                          ],
                          "type": "Content",
                          "abstractKey": "__isContent"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksContentInterestArticle",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sentiment",
                          "storageKey": null
                        },
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ArticleTypeSegment",
                          "kind": "LinkedField",
                          "name": "types",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ArticleType",
                              "kind": "LinkedField",
                              "name": "value",
                              "plural": true,
                              "selections": (v6/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Topic",
                          "kind": "LinkedField",
                          "name": "topics",
                          "plural": true,
                          "selections": (v6/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksUseCurrentArticleIdsArticle",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityUuid",
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksUseNotificationReadStatusArticle",
                      "selections": (v7/*: any*/),
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "onboardingNewsletterSubscriptionArticle",
                      "selections": (v8/*: any*/),
                      "args": null,
                      "argumentDefinitions": []
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "args": (v4/*: any*/),
              "argumentDefinitions": (v0/*: any*/)
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentNotificationSectionAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Section",
                      "kind": "LinkedField",
                      "name": "fullSectionPath",
                      "plural": true,
                      "selections": (v9/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "Section",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SectionSegment",
                      "kind": "LinkedField",
                      "name": "sections",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Section",
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": true,
                          "selections": (v9/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentTakeoverAdSectionsAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v8/*: any*/),
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Section",
                      "kind": "LinkedField",
                      "name": "fullSectionPath",
                      "plural": true,
                      "selections": (v7/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "Section",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SectionSegment",
                      "kind": "LinkedField",
                      "name": "sections",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Section",
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": true,
                          "selections": (v10/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Section",
                      "kind": "LinkedField",
                      "name": "fullSectionPath",
                      "plural": true,
                      "selections": (v10/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "Section",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "type": "Base",
          "abstractKey": "__isBase"
        }
      ],
      "args": (v4/*: any*/),
      "argumentDefinitions": (v0/*: any*/)
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "6e445f46c71410dffcd80c1a6387b04c";

export default node;
